import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { combineLatest } from 'rxjs';

export type CssUnit = 'rem' | 'px';

@Component({
  selector: 'csi-hover-error-information',
  templateUrl: './hover-error-information.component.html',
  styleUrls: ['./hover-error-information.component.css']
})
export class HoverErrorInformationComponent implements OnInit, OnDestroy {
  @Input() groups: [FormGroup];
  @Input() includeControlKeys: string[];
  @Input() excludeControlKeys: string[];

  @Input() set hidden(invalid) {
    this.visibility = invalid ? 'visible' : 'hidden';
  }

  public visibility: string = 'hidden';

  constructor() {}
  ngOnDestroy(): void {
    this.visibility = 'hidden';
  }

  ngOnInit() {
    this.groups.forEach(group => {
      combineLatest(group['submitted$'], group.statusChanges).subscribe(([submitted, status]) => {
        if (submitted) {
          if (this.excludeControlKeys) {
            this.hidden = Object.entries(group.controls).some(([key, control]) => {
              return control.invalid && !this.excludeControlKeys.includes(key);
            });
          } else if (this.includeControlKeys) {
            this.hidden = this.includeControlKeys.some(key => group.controls[key].invalid);
          }
        }
      });
    });
  }
}
